<template>
  <div id="app">
    <!-- <keep-alive>
     <router-view/>
    </keep-alive> -->
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive> -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
<style>
/* @import './style/public_pc.css'; */
</style>
<style>
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue